function paramsToObject(entries) {
    const result = {}
    for(const [key, value] of entries) {
        result[key] = value;
    }
    return result;
}

const scrollElements = document.querySelectorAll('[data-scroll-to]');
const urlSearchParams = new URLSearchParams(window.location.search);
const params = paramsToObject(urlSearchParams.entries());

if (scrollElements) {
    scrollElements.forEach(element => {
        if (!params || !params.send || params.fid !== element.id.replace('dynamic_form', '')) return;
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    });
}
